import React, { useEffect, useState } from "react";
import { Formik, Field, FieldArray, Form, getIn } from "formik";
import {
  VStack,
  HStack,
  Text,
  Button,
  Spinner,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Badge,
} from "@chakra-ui/react";
import { StepProps } from "../../../../../../../utils/types/step";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../../redux/reducer/rootReducer";
import * as Yup from "yup";
import StepHeader from "../../../../../../../components/StepperHeader";
import {
  AddIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  DeleteIcon,
} from "@chakra-ui/icons";
import { saveFormData } from "../../../../../../../redux/slice/formSlice";
import { color } from "../../../../../../../utils/theme";
import FormInput from "../../../../../../../components/input";
import AppDrawer from "../../../../../../../components/drawer";

export interface ChangeIdea {
  problem: string;
  actionVerb: string;
  changeIdea: string[];
}
export interface ChangeIdeas {
  changeIdeas: ChangeIdea[];
}

const ChangeIdeaGeneration = (props: StepProps) => {
  const [showChangeIdeaModal, setShowAddChangeIdeaModal] = useState(false);
  const onClose = () => setShowAddChangeIdeaModal(false);
  const onOpen = () => setShowAddChangeIdeaModal(true);
  const [loading, setLoading] = useState(true);
  const priotizeData = useSelector(
    (state: RootState) => state.form.formData["5"]
  );

 
  const handleSubmit = (values: any) => {
    console.log("change idea values: ", values);
    console.log("change idea values: ", values.changeIdeas);

    let data = values.changeIdeas.map((value: ChangeIdea) => {
      return {
        problem: value.problem,
        actionVerb: value.actionVerb,
        changeIdea: value.changeIdea,
      };
    });

    console.log("change idea data: ", data);

    props.onNext();
    dispatch(saveFormData({ step: "7", data: data }));
  };

  const [initialValues, setInitialValues] = useState<ChangeIdeas>({
    changeIdeas: [],
  });

  const [viewChangeIdeas, setViewChangeIdeas] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const dispatch = useDispatch();
  const rankData = useSelector((state: RootState) => state.form.formData["6"]);
  

  const schema = Yup.object().shape({
    changeIdeas: Yup.array().of(
      Yup.object().shape({
        problem: Yup.string().required("Required"),
        actionVerb: Yup.string().required("Required"),
        changeIdea: Yup.array()
          .of(Yup.string().required("Required"))
          .min(1, "At least one change idea is required"),
      })
    ),
  });

  useEffect(() => {
    const rankArray = Object.values(rankData);


    const changeIdeas = rankArray.map((rankItem: ChangeIdea) => ({
      problem: rankItem.problem,
      actionVerb: rankItem.actionVerb,
      changeIdea: [],
    }));

    setInitialValues({ changeIdeas });
  }, [rankData]);


  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 10);
  }, [initialValues]);

  const [changeIdea, setChangeIdea] = useState("");
  const [changeIdeas, setChangeIdeas] = useState<string[]>([]);
  const [addChangeIdeaLoading, setAddChangeIdeaLoading] = useState(false);

  return (
    <>
      {viewChangeIdeas && (
        <AppDrawer
          placement="right"
          title="Change Ideas"
          size="md"
          children={
            <VStack spacing={4}>
              <HStack
                w="95%"
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignSelf={"flex-start"}
              >
                <Text
                  fontSize={16}
                  pl={4}
                  fontWeight={"700"}
                  color={color.text}
                >
                  Change Idea
                </Text>
              </HStack>
              {changeIdeas.map((idea, index) => (
                <HStack
                  key={`${idea}-${index}`}
                  w="full"
                  p={4}
                  bg="gray.50"
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  gap={4}
                >
                  <Text fontSize={18} fontWeight={"500"} color={color.text}>
                    {idea}
                  </Text>
                  <HStack gap={5}>
                    <DeleteIcon
                      color={"red.500"}
                      bg={"gray.200"}
                      p={1}
                      borderRadius={5}
                      fontSize={27}
                      onClick={() => {
                        let updatedChangeIdeas = [...initialValues.changeIdeas];
                        updatedChangeIdeas[selectedIndex].changeIdea =
                          changeIdeas.filter((_, i) => i !== index);

                        setInitialValues({ changeIdeas: updatedChangeIdeas });
                        setViewChangeIdeas(false);
                      }}
                    />
                  </HStack>
                </HStack>
              ))}
            </VStack>
          }
          onClose={() => setViewChangeIdeas(false)}
        />
      )}
      <Modal isOpen={showChangeIdeaModal} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Change Idea</ModalHeader>
          <ModalCloseButton />
          <ModalBody sx={{ display: "flex", gap: 3, flexDirection: "column" }}>
            <>
              <FormInput
                name="changeIdea"
                isRequired={true}
                value={changeIdea}
                label="Change Idea"
                type="text"
                id="changeIdea"
                errorMessage={
                  changeIdea === "" ? "Change Idea is required" : ""
                }
                onChange={(event) => {
                  setChangeIdea(event.target.value);
                }}
              />
            </>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              isLoading={addChangeIdeaLoading}
              isDisabled={changeIdea === ""}
              onClick={async () => {
                let updatedChangeIdeas = [...initialValues.changeIdeas];
                updatedChangeIdeas[selectedIndex].changeIdea.push(changeIdea);

                setInitialValues({ changeIdeas: updatedChangeIdeas });
                setChangeIdea("");
                onClose();
              }}
              w={"100%"}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <StepHeader
        title="Change Idea"
        description="Now that we have listed possible root causes for our Problem, we need to prioritize them based on their frequency and severity. By focusing on the most significant issues, we can allocate resources effectively and implement changes that will have the greatest outcome."
      />
      {initialValues.changeIdeas.length === 0 || loading ? (
        <Spinner />
      ) : (
        <>
          {/* Header Row */}
          <HStack
            display="flex"
            flexDirection="row"
            w="full"
            gap={10}
            my={4}
            px={5}
            borderBottomWidth={1}
            pb={4}
            borderRadius={5}
            alignItems="center"
          >
            <Text flex={0.05} textAlign="left">
              #
            </Text>
            <Text flex={0.2} textAlign="left">
              Problem List
            </Text>

            <Text flex={0.45} textAlign="left">
              Change Idea
            </Text>
            <Text flex={0.3} textAlign="left">
              Action Verb
            </Text>
          </HStack>

          {/* Formik Body */}
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validateOnBlur={true}
            validationSchema={schema}
            onSubmit={handleSubmit}
          >
            {({ values, errors, isValid, handleChange }) => (
              <Form>
                <FieldArray
                  name="changeIdeas"
                  render={({ remove, push }) => (
                    <>
                      {values.changeIdeas.map(
                        (changeIdea: ChangeIdea, index: number) => (
                          <HStack
                            key={index}
                            display="flex"
                            flexDirection="row"
                            w="full"
                            px={5}
                            py={2}
                            gap={10}
                            borderRadius={5}
                            alignItems="center"
                            m={1}
                          >
                            <Text flex={0.05} textAlign="left">
                              {index + 1}
                            </Text>
                            <Text flex={0.2} textAlign="left">
                              {changeIdea.problem}
                            </Text>
                            <HStack flex={0.45} align="stretch">
                              {changeIdea.changeIdea.length > 0 && (
                                <Button
                                  colorScheme="blue"
                                  variant={"outline"}
                                  size={"sm"}
                                  rightIcon={
                                    <Badge ml="1" colorScheme="green">
                                      {changeIdea.changeIdea.length}
                                    </Badge>
                                  }
                                  onClick={() => {
                                    setChangeIdeas(changeIdea.changeIdea);
                                    setViewChangeIdeas(true);
                                  }}
                                >
                                  View Change Idea
                                </Button>
                              )}
                              <VStack>
                                <Button
                                  alignSelf={"flex-start"}
                                  colorScheme="blue"
                                  size={"sm"}
                                  leftIcon={<AddIcon />}
                                  onClick={() => {
                                    setSelectedIndex(index);
                                    onOpen();
                                  }}
                                >
                                  Add Change Idea
                                </Button>
                                {getIn(
                                  errors,
                                  `changeIdeas[${index}].changeIdea`
                                ) && (
                                  <Text color="red" fontSize="sm">
                                    {getIn(
                                      errors,
                                      `changeIdeas[${index}].changeIdea`
                                    )}
                                  </Text>
                                )}
                              </VStack>
                            </HStack>
                            <VStack flex={0.3} align="stretch">
                              <Field
                                as={Input}
                                style={{
                                  border: getIn(
                                    errors,
                                    `changeIdeas[${index}].actionVerb`
                                  )
                                    ? "1px solid red"
                                    : "1px solid #E2E8F0",
                                }}
                                name={`changeIdeas[${index}].actionVerb`}
                              />
                            </VStack>
                          </HStack>
                        )
                      )}
                    </>
                  )}
                />
                {/* Footer Buttons */}
                <HStack
                  flex={0.1}
                  mt="auto"
                  w="full"
                  justifyContent="space-between"
                  p={4}
                  bg="gray.50"
                >
                  <Button
                    colorScheme="blue"
                    variant="outline"
                    leftIcon={<ArrowLeftIcon />}
                    onClick={() => {
                      if (props.onPrev) {
                        props.onPrev();
                      }
                    }}
                  >
                    Previous
                  </Button>
                  <HStack>
                    <Button
                      isDisabled={!isValid}
                      colorScheme="blue"
                      variant="outline"
                    >
                      Save & Exit
                    </Button>
                    <Button
                      colorScheme="blue"
                      type="submit"
                      isDisabled={!isValid}
                      w="50%"
                      rightIcon={<ArrowRightIcon />}
                      onClick={() => {
                        console.log(
                          "Error: ",
                          getIn(errors, `changeIdeas[${1}].changeIdea`)
                        );
                      }}
                    >
                      Next
                    </Button>
                  </HStack>
                </HStack>
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};

export default ChangeIdeaGeneration;
